import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import Header from '../components/header';
import Footer from '../components/footer';


const Template = inject("stores") (
    observer (
        class Template extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.state = {
                }

                this.storeUi = this.props.stores.storeUi;
            }

            render() {
                return (
                    <React.Fragment>
                        <Header 
                            hide_navigation = {this.props.hide_navigation}
                        />
                        <div className="page">
                            {this.props.children}            
                        </div>
                        <Footer 
                            hide_navigation = {this.props.hide_navigation}
                        />
                    </React.Fragment>
                );
            }
        }
    )
)

export default Template;
